<template>
  <div class="va-icon-menu-collapsed-wrapper" :class="{ 'auto-mode': autoCollapse }">
    <svg class="va-icon-menu-collapsed" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fill-rule="nonzero">
        <path d="M0 0h24v24H0z" />
        <rect :fill="color" height="2" rx="1" width="20" x="2" y="3" />
        <path
          :fill="color"
          d="M3 11h10a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2zM20.993 11l-2.7-2.7-1.414 1.414L18.164 11H16a1 1 0 0 0 0 2h2.179l-1.3 1.3 1.414 1.414L21.007 13A1 1 0 0 0 21 11h-.007z"
        />
        <rect :fill="color" height="2" rx="1" width="20" x="2" y="19" />
      </g>
    </svg>
    <span
      class="mode-indicator"
      :title="autoCollapse ? 'Click to switch to Manual mode' : 'Click to switch to Auto mode'"
      @click.stop="handleModeToggle"
    >
      {{ autoCollapse ? 'A' : 'M' }}
    </span>
  </div>
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    color?: string
    autoCollapse?: boolean
  }>(),
  {
    color: 'inherit',
    autoCollapse: true,
  },
)

const emit = defineEmits<{
  'toggle-mode': []
}>()

const handleModeToggle = () => {
  emit('toggle-mode')
}
</script>

<style lang="scss">
.va-icon-menu-collapsed-wrapper {
  position: relative;
  display: inline-block;
  width: 24px;
  height: 24px;
}

.va-icon-menu-collapsed {
  display: inline-block;
  width: 24px;
  height: 24px;
}

.mode-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 10px;
  font-weight: bold;
  color: #ffffff;
  text-shadow:
    0 0 2px rgba(0, 0, 0, 0.8),
    0 0 4px rgba(0, 0, 0, 0.6);
  pointer-events: auto;
  line-height: 1;
  z-index: 2;
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 3px;
  transition: all 0.2s ease;
  user-select: none;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
    transform: translate(-50%, -50%) scale(1.2);
    text-shadow:
      0 0 4px rgba(0, 0, 0, 1),
      0 0 6px rgba(0, 0, 0, 0.8);
  }

  &:active {
    transform: translate(-50%, -50%) scale(1.1);
  }
}

.auto-mode .mode-indicator {
  color: #4ade80; // Green for Auto mode
}

.va-icon-menu-collapsed-wrapper:not(.auto-mode) .mode-indicator {
  color: #fbbf24; // Amber/Yellow for Manual mode
}
</style>
